import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { MaxBrainWidget } from '../models/widget.model';

export class SetWidget {
    static readonly type = '[Widget] SetWidget';

    constructor(public payload: MaxBrainWidget) {}
}

export class UnsetWidget {
    static readonly type = '[Widget] UnsetWidget';
}

export class FetchWidget {
    static readonly type = '[Widget] FetchWidget';

    constructor(public payload: string) {}
}

export class FetchWidgetSuccess {
    static readonly type = '[Widget] FetchWidgetSuccess';

    constructor(public payload: MaxBrainWidget) {}
}

export class FetchWidgetFailure {
    static readonly type = '[Widget] FetchWidgetFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreateWidget {
    static readonly type = '[Widget] CreateWidget';

    constructor(public payload: MaxBrainWidget) {}
}

export class CreateWidgetSuccess {
    static readonly type = '[Widget] CreateWidgetSuccess';

    constructor(public payload: MaxBrainWidget) {}
}

export class CreateWidgetFailure {
    static readonly type = '[Widget] CreateWidgetFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdateWidget {
    static readonly type = '[Widget] UpdateWidget';

    constructor(public payload: MaxBrainWidget) {}
}

export class UpdateWidgetSuccess {
    static readonly type = '[Widget] UpdateWidgetSuccess';

    constructor(public payload: MaxBrainWidget) {}
}

export class UpdateWidgetFailure {
    static readonly type = '[Widget] UpdateWidgetFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}
export class DeleteWidget {
    static readonly type = '[Widget] DeleteWidget';

    constructor(public payload: string) {}
}

export class DeleteWidgetSuccess {
    static readonly type = '[Widget] DeleteWidgetSuccess';

    constructor(public payload: string) {}
}

export class DeleteWidgetFailure {
    static readonly type = '[Widget] DeleteWidgetFailure';

    constructor(public payload: string) {}
}

export class SetWidgets {
    static readonly type = '[Widget] SetWidgets';

    constructor(public payload: MaxBrainWidget[]) {}
}

export class FetchWidgets {
    static readonly type = '[Widget] FetchWidgets';
}

export class FetchWidgetsSuccess {
    static readonly type = '[Widget] FetchWidgetsSuccess';
}

export class FetchWidgetsFailure {
    static readonly type = '[Widget] FetchWidgetsFailure';
}

export class ToggleSelectedWidget {
    static readonly type = '[Widget] ToggleSelectedWidget';

    constructor(public payload: string) {}
}

export class SelectFilteredWidgets {
    static readonly type = '[Widget] SelectFilteredWidgets';
}

export class DeselectSelectedWidgets {
    static readonly type = '[Widget] DeselectSelectedWidgets';
}

export class SearchWidgets {
    static readonly type = '[Widget] SearchWidgets';

    constructor(public payload: string) {}
}
